@if (installationForm) {
  <ion-grid class="ion-no-padding">
    <form [formGroup]="installationForm">
      @if (!isInEditMode()) {
        <ion-row class="pb-05">
          <ion-col
            size="3"
            size-xs="3"
            size-md="3"
            size-lg="3"
            class="ion-align-self-center"
          >
            <ion-label class="panel-label-text">{{
              'installation_origin' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="9" size-xs="9" size-md="9" size-lg="9">
            <ion-segment formControlName="originId">
              <ion-segment-button [value]="1">
                <ion-label>{{ 'installation_originQC' | translate }}</ion-label>
              </ion-segment-button>
              <ion-segment-button [value]="2">
                <ion-label>{{
                  'installation_originQCP' | translate
                }}</ion-label>
              </ion-segment-button>
            </ion-segment>
          </ion-col>
        </ion-row>
      }
      <ion-row class="pb-05">
        <ion-col
          size="3"
          size-xs="3"
          size-md="3"
          size-lg="3"
          class="ion-align-self-center"
        >
          <ion-label class="panel-label-text">{{
            'installation_favorite' | translate
          }}</ion-label>
        </ion-col>
        <ion-col
          class="ionic-toggle"
          size="9"
          size-xs="9"
          size-md="9"
          size-lg="9"
        >
          <ion-label class="panel-label-text">{{
            'installation_favorite_no' | translate
          }}</ion-label>
          <ion-toggle color="primary" formControlName="favorite"> </ion-toggle>
          <ion-label class="panel-label-text">{{
            'installation_favorite_yes' | translate
          }}</ion-label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          size="3"
          size-xs="3"
          size-md="3"
          size-lg="3"
          class="ion-align-self-center"
        >
          <ion-label class="panel-label-text align-label">{{
            'installation_name' | translate
          }}</ion-label>
        </ion-col>
        <ion-col size="9" size-xs="9" size-md="9" size-lg="9">
          <ion-input
            placeholder="{{ 'installation_name' | translate }}"
            formControlName="name"
            [ngClass]="
              formHelper.isFieldValidCss('name', isFormSubmitAttempted())
            "
          >
          </ion-input>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          size="3"
          size-xs="3"
          size-md="3"
          size-lg="3"
          class="ion-align-self-center"
        >
          <ion-label class="panel-label-text align-label">{{
            'installation_streetNr' | translate
          }}</ion-label>
        </ion-col>
        <ion-col size="9" size-xs="9" size-md="9" size-lg="9">
          <ion-input
            placeholder="{{ 'installation_streetNr' | translate }}"
            formControlName="addressLine1"
            [ngClass]="
              formHelper.isFieldValidCss(
                'addressLine1',
                isFormSubmitAttempted()
              )
            "
          ></ion-input>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          size="3"
          size-xs="3"
          size-md="3"
          size-lg="3"
          class="ion-align-self-center"
        >
          <ion-label class="panel-label-text align-label">{{
            'installation_postalcode' | translate
          }}</ion-label>
        </ion-col>
        <ion-col size="9" size-xs="9" size-md="9" size-lg="9">
          <ion-input
            placeholder="{{ 'installation_postalcode' | translate }}"
            formControlName="postalCode"
            [ngClass]="
              formHelper.isFieldValidCss('postalCode', isFormSubmitAttempted())
            "
          ></ion-input>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          size="3"
          size-xs="3"
          size-md="3"
          size-lg="3"
          class="ion-align-self-center"
        >
          <ion-label class="panel-label-text align-label">{{
            'installation_city' | translate
          }}</ion-label>
        </ion-col>
        <ion-col size="9" size-xs="9" size-md="9" size-lg="9">
          <ion-input
            placeholder="{{ 'installation_city' | translate }}"
            formControlName="city"
            [ngClass]="
              formHelper.isFieldValidCss('city', isFormSubmitAttempted())
            "
          >
          </ion-input>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          size="3"
          size-xs="3"
          size-md="3"
          size-lg="3"
          class="ion-align-self-center"
        >
          <ion-label class="panel-label-text align-label">{{
            'installation_country' | translate
          }}</ion-label>
        </ion-col>
        <ion-col size="9" size-xs="9" size-md="9" size-lg="9">
          <ion-item
            [ngClass]="
              formHelper.isFieldValidCss('country', isFormSubmitAttempted())
            "
            class="position-relative"
          >
            <ion-label>&nbsp;</ion-label>
            @if (countriesData()) {
              <ionic-selectable
                formControlName="country"
                [shouldFocusSearchbar]="true"
                [items]="countriesData()"
                itemValueField="id"
                itemTextField="name"
                [canSearch]="true"
              >
              </ionic-selectable>
            }
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          size="3"
          size-xs="3"
          size-md="3"
          size-lg="3"
          class="ion-align-self-center"
        >
          <ion-label class="panel-label-text align-label">{{
            'installation_timezone' | translate
          }}</ion-label>
        </ion-col>
        <ion-col size="9" size-xs="9" size-md="9" size-lg="9">
          <ion-item
            [ngClass]="
              formHelper.isFieldValidCss('timezone', isFormSubmitAttempted())
            "
          >
            @if (timezoneData()) {
              <ion-label>&nbsp;</ion-label>
              <ionic-selectable
                formControlName="timezone"
                [shouldFocusSearchbar]="true"
                [items]="timezoneData()"
                itemValueField="id"
                itemTextField="name"
                [canSearch]="true"
              >
              </ionic-selectable>
            }
          </ion-item>
        </ion-col>
      </ion-row>
      @if (canShowButton()) {
        <ion-row class="ion-margin-top pb-1">
          <ion-col
            size="3"
            size-xs="3"
            size-md="3"
            size-lg="3"
            class="ion-align-self-end"
          >
          </ion-col>
          <ion-col
            size="9"
            size-xs="9"
            size-md="9"
            size-lg="9"
            class="ion-align-self-end"
          >
            <ion-button
              type="button"
              color="primary"
              (click)="onSubmit()"
              [disabled]="
                !installationForm.valid ||
                !canAddInstallation() ||
                isFormDisabled()
              "
            >
              <small>{{ btn_text() | translate }}</small>
            </ion-button>
          </ion-col>
        </ion-row>
      }
      @if (showNextPrevButtons()) {
        <ion-row>
          <ion-col>
            <ion-button
              class="ion-float-left"
              type="button"
              color="primary"
              (click)="onPrevClicked()"
            >
              <small>{{ 'general_prev' | translate }}</small>
            </ion-button>
            <ion-button
              class="ion-float-right"
              type="button"
              color="primary"
              (click)="onNextWithData()"
              [disabled]="!installationForm.valid || isUpdating()"
            >
              <small>{{ 'general_next' | translate }}</small>
            </ion-button>
          </ion-col>
        </ion-row>
      }
    </form>
  </ion-grid>
}
